import { Alert } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

import ReportingHubForm from '../components/ReportingHub/ReportingHubForm';
import reportTemplateDefaultList from '../constants/reportTemplateDefaultList';
import mapReportTemplateToForm from '../util/mapReportTemplateToForm';
import { ReportTemplate } from '../validationSchemas/ReportTemplateSchema';

function ReportingHubEditPage() {
  const { reportTemplateId } = useParams();
  const data = reportTemplateDefaultList.find((item) => item.reportTemplate.templateId === Number(reportTemplateId));

  if (!data) {
    return <Alert severity="error">Unable to load template</Alert>;
  }

  const form:ReportTemplate = mapReportTemplateToForm(data.reportTemplate);
  // Delete the template ID because this is a default template and not linked to any template ID in the database.
  // This will also tell the ReportingHubForm to create a new template.
  form.templateId = null;
  form.reportName = `Copy of ${form.reportName}`;
  return <ReportingHubForm reportTemplate={form} />;
}

export default ReportingHubEditPage;
